import React from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { Link as RouterLink } from 'react-router-dom';
import useEntries from '../components/Common/useEntries';
import EventCard from '../components/Events/EventCard';
import { Section, SectionHeading, LinkCard } from '../components/Common/PageLayout';
import { isNewsItem } from '../components/Events/eventFilters';

const relationFields = (value) => value?.fields || value?.attributes || value?.data?.attributes || value || {};

/** Path of a page: pages are reached through the sub-menu (or main menu) they belong to. */
export function pagePath(page) {
    const subMenu = relationFields(page.fields?.sub_menu);
    const mainMenu = relationFields(page.fields?.main_menu);
    const slug = subMenu.slugMName || subMenu.slug || mainMenu.slug;
    return slug ? `/pagedetails/${slug}` : null;
}

/**
 * Home-page sections of a directorate subdomain: the directorate's latest news and its pages,
 * i.e. entries whose `directorate` is this directorate in the CMS. Shown below its profile.
 */
export default function SubdomainHighlights({ directorateSlug }) {
    const news = useEntries({
        content_type: 'events',
        'fields.directorate.slug': directorateSlug,
        order: '-sys.createdAt',
        limit: 6,
    });
    const pages = useEntries({
        content_type: 'collectionpagedetail',
        'fields.directorate.slug': directorateSlug,
        limit: 50,
    });

    const latestNews = news.items.filter(isNewsItem).slice(0, 3);
    const linkedPages = pages.items
        .map((page) => ({ page, path: pagePath(page) }))
        .filter((item) => item.path);

    return (
        <>
            {latestNews.length > 0 && (
                <Section>
                    <SectionHeading title="Latest news" />
                    <Grid container spacing={3}>
                        {latestNews.map((entry) => (
                            <Grid item xs={12} sm={6} md={4} key={entry.sys.id}>
                                <EventCard event={entry} />
                            </Grid>
                        ))}
                    </Grid>
                    <div style={{ marginTop: 24 }}>
                        <Button component={RouterLink} to="/latestnews" variant="outlined" color="primary">
                            All news
                        </Button>
                    </div>
                </Section>
            )}
            {linkedPages.length > 0 && (
                <Section tone="muted" bordered>
                    <SectionHeading title="Pages" />
                    <Grid container spacing={3}>
                        {linkedPages.map(({ page, path }) => (
                            <Grid item xs={12} sm={6} md={4} key={page.sys.id}>
                                <LinkCard title={page.fields?.title || 'Page'} to={path} cta="Open page" />
                            </Grid>
                        ))}
                    </Grid>
                </Section>
            )}
        </>
    );
}
